/* global YT */
import $ from 'jquery';

var isLoaded = false;
var info = {};
var player = null;

export default {
  show: function () {
    var $con = $('.youtube-player');
    var $video = $('.youtube-player__container');

    $con.css('visibility', 'hidden').show();

    // 플레이어의 상단 헤더영역은 48px
    $video.css({
      width: info.width,
      height: info.height,
      marinLeft: info.width / -2,
      marginTop: info.height / -2 - 24
    });

    $con.css('visibility', 'visible');

    return this;
  },

  hide: function () {
    $('.youtube-player').hide();

    return this;
  },

  play: function () {
    if (isLoaded) {
      player.playVideo();
    } else {
      // TODO: 유튜브 스크립트가 초기화되기 전에 유저가 플레이어 클릭 시
    }
  },

  stop: function () {
    if (isLoaded) {
      player.stopVideo();
    }

    return this;
  },

  init: function (sel) {
    var $pyt = $(sel);

    info = {
      placeholder: $('.youtube-player__placeholder')[0],
      title: $pyt.data('title') || '',
      width: $pyt.data('width') || 854,
      height: $pyt.data('height') || 480,
      videoId: $pyt.attr('href').split('/').pop() // ex: https://youtu.be/VQtonf1fv_s
    };

    $('.youtube-player__title').text(info.title);

    player = new YT.Player(info.placeholder, {
      width: info.width,
      height: info.height,
      videoId: info.videoId,
      origin: window.location.origin,
      events: {
        onReady: function (/* event */) {
          isLoaded = true;
        }
      }
    });
  }
};
